import { render, staticRenderFns } from "./AdminPredefinedAnswerActions.vue?vue&type=template&id=c66f0a84&"
import script from "./AdminPredefinedAnswerActions.vue?vue&type=script&lang=ts&"
export * from "./AdminPredefinedAnswerActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip});
